import { AsyncPortal } from "@circle-react-uikit/AsyncPortal";

import { STANDARD_LAYOUT_V2_COVER_IMAGE_CONTAINER } from "@/react/components/constants";
import { CoverImage } from "@/react/components/Layout/StandardLayoutV2/CoverImage";

import type { FormValues } from "../CoverImageForm";
import { CoverImageForm } from "../CoverImageForm";
import { MobileCoverImage } from "../MobileCoverImage";

const id = `#${STANDARD_LAYOUT_V2_COVER_IMAGE_CONTAINER}`;

export interface CoverImageFormPortal {
  coverImage: string;
  enabled: boolean;
  isLoading: boolean;
  isMobile: boolean;
  onDelete: () => void;
  onSubmit: (values: FormValues) => void;
  showForm: boolean;
  thumbnailImage?: string;
}

export const CoverImageFormPortal = ({
  coverImage,
  enabled = true,
  isMobile = false,
  isLoading = false,
  onDelete,
  onSubmit,
  showForm = false,
  thumbnailImage,
}: CoverImageFormPortal) => {
  if (!enabled) {
    return null;
  }

  if (isMobile) {
    return (
      <MobileCoverImage
        thumbnailImageUrl={thumbnailImage}
        coverImageUrl={coverImage}
      />
    );
  }

  return (
    <AsyncPortal selectorQuery={id}>
      {showForm ? (
        <CoverImageForm
          url={coverImage}
          onSubmit={onSubmit}
          onDelete={onDelete}
          isLoading={isLoading}
        />
      ) : (
        coverImage && <CoverImage url={coverImage} />
      )}
    </AsyncPortal>
  );
};
